import useGetProfileAdvancedViewData from './useGetProfileAdvancedViewData'

export default useGetProfileAdvancedViewData
